
<div>
	<h1 mat-dialog-title>{{ data.header }}</h1>
	<span> {{ data.message }} </span>
</div>
